// MF-67 — Card frame for one insight chart: title + one-line description, then the plot.
import { Typography } from '@mui/material'

const ChartCard = ({ title, description, children, style }) => (
  <div
    className='flex flex-col'
    style={{
      gap: 12,
      padding: 20,
      background: '#fff',
      border: '1px solid rgb(226, 232, 240)',
      borderRadius: 12,
      minWidth: 0,
      ...style
    }}
  >
    <div className='flex flex-col' style={{ gap: 2 }}>
      <Typography style={{ fontSize: 14, fontWeight: 600, color: 'rgb(15, 23, 42)' }}>{title}</Typography>
      {description ? (
        <Typography style={{ fontSize: 12, color: 'rgb(100, 116, 139)' }}>{description}</Typography>
      ) : null}
    </div>
    {children}
  </div>
)

export default ChartCard
